import React from "react"
import { FaChevronLeft } from "react-icons/fa"

import DpBottomButtons from "./DpBottomButtons"
import DpTimeInputs from "./DpTimeInputs"
import DpTopButtons from "./DpTopButtons"
import classes from "./index.module.scss"

const DpTimePicker = props => {
  const {
    type,
    timeRange,
    setTimeRange,
    timeRangeStep,
    setTimeRangeStep,
    selectedTime,
    setSelectedTime,
    setContent
  } = props

  const showChevron =
    type === "rangeTimePicker" ?
      timeRangeStep === "end" :
      type !== "timePicker"

  return (
    <div className={classes["container"]}>
      {
        showChevron &&
        <button
          className={classes["close-button"]}
          onClick={() => timeRangeStep === "end" ? setTimeRangeStep("start") : setContent("days")}
        >
          <FaChevronLeft />
        </button>
      }
      <div className={classes["wrapper"]}>
        <DpTopButtons
          type={type}
          timeRangeStep={timeRangeStep}
          timeRange={timeRange}
          setTimeRange={setTimeRange}
          selectedTime={selectedTime}
          setSelectedTime={setSelectedTime}
        />
        <DpTimeInputs
          type={type}
          timeRangeStep={timeRangeStep}
          timeRange={timeRange}
          setTimeRange={setTimeRange}
          selectedTime={selectedTime}
          setSelectedTime={setSelectedTime}
        />
        <DpBottomButtons
          type={type}
          timeRangeStep={timeRangeStep}
          timeRange={timeRange}
          setTimeRange={setTimeRange}
          selectedTime={selectedTime}
          setSelectedTime={setSelectedTime}
        />
        <div className={classes["dots"]}>
          :
        </div>
      </div>
    </div >
  )
}

export default DpTimePicker